module.exports = __webpack_public_path__ + "fonts/ARIALN.0db23b28.TTF";